import { Txt } from '@stenajs-webui/core';
import { cssColor } from '@stenajs-webui/theme';
import type { FC } from 'react';
import { useLocalDateFormat } from '../../../../common/hooks/useLocalDateFormat';
import { formatDateTime } from '../../../../common/utils/dates/dateUtils';
import styles from './HistoryTable.module.css';

export interface HistoryRow {
  by: string;
  status: string;
  time: Date;
}

export interface HistoryTableProps {
  rows: HistoryRow[];
}

export const HistoryTable: FC<HistoryTableProps> = ({ rows }) => {
  const dateFormat = useLocalDateFormat();

  return (
    <table>
      <thead>
        <tr>
          <th className={styles.header}>
            <Txt variant={'bold'} color={cssColor('--lhds-color-ui-900')}>
              Status
            </Txt>
          </th>
          <th className={styles.header}>
            <Txt variant={'bold'} color={cssColor('--lhds-color-ui-900')}>
              Time
            </Txt>
          </th>
          <th className={styles.header}>
            <Txt variant={'bold'} color={cssColor('--lhds-color-ui-900')}>
              By
            </Txt>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map(({ by, time, status }, index) => (
          <tr key={index}>
            <td className={styles.cell}>
              <Txt>{status}</Txt>
            </td>
            <td className={styles.cell}>
              <Txt>{formatDateTime(time, dateFormat)}</Txt>
            </td>
            <td className={styles.cell}>
              <Txt>{by}</Txt>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
